module.exports = __webpack_public_path__ + "img/1450521848.59312970.jpg";